module.exports = __webpack_public_path__ + "img/contributionplanner-howitworks3.64dfac46.svg";